import { render } from "./coursewareItem.vue?vue&type=template&id=dae43918"
import script from "./coursewareItem.vue?vue&type=script&lang=js"
export * from "./coursewareItem.vue?vue&type=script&lang=js"

import "./coursewareItem.vue?vue&type=style&index=0&id=dae43918&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__